// extracted by mini-css-extract-plugin
export default {"endOfResults":"search_end_results_message-module__endOfResults--ItSZZ"};